/* Declare window only one time */


var w = jQuery(window);
